import React from 'react';

const Footer = () => {
    return (
        <div className="p-4" style={{
                
                backgroundColor: "#2f997bf7",
                color: "black",


            }}>
            <h1>Copyright © 2021 foodie.dipta</h1>
        </div>
    );
};

export default Footer;